import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
window.tippy = tippy;

import multi from "multi.js/dist/multi-es6.min.js";
import "multi.js/dist/multi.min.css";
window.multi = multi;

import intlTelInput from 'intl-tel-input';
import "intl-tel-input/build/css/intlTelInput.css";
window.intlTelInput = intlTelInput;

window.Alpine = Alpine;
Alpine.store('spaTransition', {
    on: false,
    toggle() {
        this.on = ! this.on;
        setTimeout(() => { return; }, 300);
    }
})
Alpine.plugin(collapse);
Alpine.start();

/* Función global para actualizar por evento global del navegador el multijs (doble clic simulado) */
window.updateMultijs = function() {
    var nonSelectedOptions = document.querySelector('div.multi-wrapper .non-selected-wrapper').getElementsByTagName('a');
    nonSelectedOptions[0].click();
    nonSelectedOptions[0].click();
}

/* AsyncAPI generator */
window.asyncApiGenerator = function() {
    console.log('misco');
    const path = require('path');
    const generator = new Generator('@asyncapi/html-template', path.resolve(__dirname, 'example'));
    generator.generateFromURL('https://raw.githubusercontent.com/asyncapi/asyncapi/2.0.0/examples/2.0.0/streetlights.yml')
        .then(() => {
            console.log('Done!');
        })
        .catch(console.error);
}
